import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Processing } from 'react-wot-bootstrap'

import Stronghold from 'containers/Stronghold/Stronghold'
import { requestShopProducts } from 'state/actions/shop'
import { requestBalance } from 'state/actions/balance'
import { addWOTClientListener, C2W_EVENT_TYPES, removeWOTClientListener } from '@wotfe/client2web'

import styles from './ShopView.scss'
import { push } from 'react-router-redux'
import { SHOP_ERROR } from 'urls'
import { ErrorIds } from 'containers/ShopView/containers/ShopErrorScreen/constants'


export class ShopView extends React.Component {
    static propTypes = {
        loaded: PropTypes.bool.isRequired,
        error: PropTypes.bool,
        errorStatus: PropTypes.number,

        onComponentDidMount: PropTypes.func.isRequired,
        onComponentWillUnmount: PropTypes.func.isRequired,
        showError: PropTypes.func.isRequired,
    }

    componentDidMount() {
        if (this.props.errorStatus === 403) {
            this.props.showError(ErrorIds.NOT_CLAN_MEMBER)
        } else {
            this.props.onComponentDidMount()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.errorStatus !== this.props.errorStatus && this.props.errorStatus === 403) {
            this.props.showError(ErrorIds.NOT_CLAN_MEMBER)
        }
    }

    componentWillUnmount() {
        this.props.onComponentWillUnmount()
    }

    render() {
        if (!this.props.loaded && !this.props.error) {
            return <Processing type="fullscreen" isVisible />
        }

        return (
            <div className={styles.base}>
                <div className={styles.strongholdBackground}>
                    <Stronghold ignoreEscape/>
                </div>
                {this.props.children}
            </div>
        )
    }
}

export const stateToProps = ({ shop, balance }) => {
    return {
        loaded: shop.productsLoaded,
        error: !!shop.errorMessage,
        errorStatus: shop.errorStatus,
        balance,
    }
}

const dispatchToProps = (dispatch) => ({
    onComponentDidMount: () => {
        dispatch(requestShopProducts())
        dispatch(requestBalance())

        addWOTClientListener(C2W_EVENT_TYPES.UPDATE_BALANCE, dispatch)
        addWOTClientListener(C2W_EVENT_TYPES.WALLET_UPDATE, dispatch)
    },
    onComponentWillUnmount: () => {
        removeWOTClientListener(C2W_EVENT_TYPES.UPDATE_BALANCE, dispatch)
        removeWOTClientListener(C2W_EVENT_TYPES.WALLET_UPDATE, dispatch)
    },
    showError: (errorId) => dispatch(push(SHOP_ERROR(errorId))),
})

export default connect(stateToProps, dispatchToProps)(ShopView)



// WEBPACK FOOTER //
// ./containers/ShopView/ShopView.jsx